export default "__VITE_ASSET__PSGRFc_m__"